import { graphql } from '../gql'

/*
 * Meilisearch-backed listing queries (`VITE_SEARCH_ENGINE=meili`). Same item shape as the legacy
 * `search` queries plus the fields that used to need the second `GET_PRODUCTS_BADGES_QUERY`:
 * min-quantity tier price (`unitPrice*`), badges (date windows already applied) and `skuMba`.
 */

export const MEILI_SEARCH_PRODUCTS_QUERY = graphql(`
  query MeiliSearchProducts($input: MeiliSearchInput!) {
    meiliSearch(input: $input) {
      items {
        productId
        productVariantId
        productName
        slug
        sku
        skuMba
        currencyCode
        unitPrice
        unitPriceWithTax
        minQuantity
        productAsset {
          preview
        }
        badges {
          isNew
          isBestSeller
          isPromotion
          isFeatured
        }
      }
      collections {
        collection {
          id
          name
          slug
          featuredAsset {
            preview
          }
        }
        count
      }
      facetValues {
        count
        facetValue {
          id
          name
          code
          facetId
          customFields
          facet {
            id
            name
            code
          }
        }
      }
      totalItems
    }
  }
`)

export const MEILI_GET_COLLECTION_QUERY = graphql(`
  query MeiliGetCollection($slug: String!, $searchInput: MeiliSearchInput!) {
    collection(slug: $slug) {
      id
      name
      slug
      description
      translations {
        languageCode
        slug
      }
      breadcrumbs {
        id
        name
        slug
      }
      children {
        id
        name
        slug
        featuredAsset {
          preview
        }
      }
    }
    meiliSearch(input: $searchInput) {
      items {
        productId
        productVariantId
        productName
        slug
        sku
        skuMba
        currencyCode
        unitPrice
        unitPriceWithTax
        minQuantity
        productAsset {
          preview
        }
        badges {
          isNew
          isBestSeller
          isPromotion
          isFeatured
        }
      }
      facetValues {
        count
        facetValue {
          id
          name
          code
          facetId
          customFields
          facet {
            id
            name
            code
          }
        }
      }
      totalItems
    }
  }
`)

/** Header autocomplete and related products: items + collections, no facets. */
export const MEILI_QUICK_SEARCH_QUERY = graphql(`
  query MeiliQuickSearch($input: MeiliSearchInput!) {
    meiliSearch(input: $input) {
      items {
        productId
        productVariantId
        productName
        slug
        sku
        skuMba
        currencyCode
        unitPrice
        unitPriceWithTax
        minQuantity
        price {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
            max
          }
        }
        priceWithTax {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
            max
          }
        }
        productAsset {
          preview
        }
        badges {
          isNew
          isBestSeller
          isPromotion
          isFeatured
        }
      }
      collections {
        collection {
          id
          name
          slug
          featuredAsset {
            preview
          }
        }
        count
      }
      totalItems
    }
  }
`)

export const MEILI_SEARCH_KIT_PRODUCTS_QUERY = graphql(`
  query MeiliSearchKitProducts($input: MeiliSearchInput!) {
    meiliSearch(input: $input) {
      items {
        productVariantId
        productVariantName
        productName
        slug
        sku
        currencyCode
        price {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
          }
        }
        priceWithTax {
          ... on SinglePrice {
            value
          }
          ... on PriceRange {
            min
          }
        }
        productVariantAsset {
          preview
        }
        productAsset {
          preview
        }
      }
      totalItems
    }
  }
`)
